import request from '../../utils/http'
import WITSBOX_ENV_PARAM from '../../utils/common'
import global from '../../utils/global'
const state = {
  // 面包削数组 记录页面跳转的url
  breadcrumbUrlArr: [],
  // 面包削 url->word key-value
  breadcrumbUrlWordMap:{
    '/user/login':'', 
    '/user/wxLogin':'', 

    '/study/center': ' 学习中心',
    '/study/schedule':'课程安排',
    '/study/salonInfo':'沙龙课详情',
    '/study/bookLessonSelect':'选择主题',
    '/study/bookSmallClassSelect':'选择主题',
    '/study/bookLessonInfo':'主题详情',
    '/study/bookSmallClassInfo':'主题详情',
    '/study/bookTimeSelect':'预约上课时间',
    '/study/timeTableSelect':'预约上课时间',
    '/study/bookConfirm':'订课详情',
    
    '/neo/neoBox':'NEO入学测试',

    '/course/courseware':'查看课件',

    '/eval/evalTeaching': '评价教师',
    '/eval/teacherOverallEval': '教师评价',
    '/eval/variousEval': '其他评价',

    '/my/endedCourse':'我的-已结束课程',
    '/my/notice': '我的-我的消息',
    '/my/noticeDetail': '消息详情',
    '/my/outerChain': '公告外链',

    '/survey/survey-answer/':'教师评价',
    '/survey/questionnaireAnswer/':'课程中期评价',

    '/follow/list': '跟进列表',
    '/follow/feedback': '跟进反馈',

    '/certificate/myCertificate': '我的证书',
    '/certificate/certificateLevel': '证书等级',
		 '/robot/intermediate': '中间页',
  },
  // 维护起始页面
  breadStartPage: [
    '/study/center',
		'/learning/index',
		'/learning/middle',
    '/',
    '/user/login',
    '/user/wxLogin',
    '/my/endedCourse',
    '/my/accountSettings',
    '/my/notice',
    '/my/myJoin',
    '/certificate/myCertificate',
    '/follow/list',
		'/robot/intermediate',
		'/mc/microCourseList',
		'/mc/microCoursDetail',
		'/mc/payment',
		'/read/planList',
		'/read/plan',
		'/read/preClassReading',
		'/read/article',
		'/read/articlePerusal',
  ],
  breadcrumbUrlQueryMap: {

  },
  //  当前顶部菜单状态
  curMenu: 1,
  userId: null, // 定义获取用户id
  token: null, // 定义token，获取用户信息的时候写入token
  userInfo: null,
  isHover: false, // 处于滚动状态-true 
  role: [],
  // 课件列表
  courseWareList: [],
  lang: 'zh', //语言
  // 上传文件的两个变量
  uploadFilePercent: 0,
  uploadFileDialogVisible: false,
  noReadMsgList: {},
	keepAlive: ['learningIndex'],
  initPageFlag: false,
  neoCodeVisible: false,  // neo弹框二维码弹框的显示
  dynedJumpVisible: false, //跳转dyned弹框
  languageDialogVisible: false // 切换语言弹出框
}
const getters = {
  breadStartPage: state => state.breadStartPage,
  breadcrumbUrlWordMap: state => state.breadcrumbUrlWordMap,
  keepAlive: (state) => state.keepAlive,
  breadcrumbUrlArr: state => {
    let arr = JSON.parse(sessionStorage.getItem('breadcrumbUrlArr'))
    if (arr) {
      return state.breadcrumbUrlArr.length === 0 ? arr : state.breadcrumbUrlArr
    } else {
      return state.breadcrumbUrlArr
    }
  },
  courseWareList: state => {
    if (state.courseWareList && state.courseWareList.dataModel && state.courseWareList.dataModel.studentCoursewareList) {
      return state.courseWareList.dataModel.studentCoursewareList
    } else if (sessionStorage.getItem('courseWareList')) {
      let rst = JSON.parse(sessionStorage.getItem('courseWareList'))
      return rst.dataModel.studentCoursewareList
    } else {
      return []
    }
  },
  role: state => state.role,
  userinfo: state => {
    return {
      userInfo: state.userInfo
    }
  },
  userId: state => {
    return {
      userId: state.userId
    }
  },
  title: state => {
    return {
      title: state.title
    }
  },
  isHover: state => state.isHover,
  lang: state => {
    let sessionState = JSON.parse(sessionStorage.getItem('lang'));
    if (sessionState != state.lang) {
      return sessionState
    }
    return state.lang
  },
  uploadFilePercent: state => {
    return state.uploadFilePercent
  },
  uploadFileDialogVisible: state => {
    return state.uploadFileDialogVisible
  },
  noReadMsgList: state => state.noReadMsgList,
  initPageFlag: state => {
    let sessionState = JSON.parse(sessionStorage.getItem('initPageFlag'));
    if (sessionState != state.initPageFlag) {
      return sessionState
    }
    return state.initPageFlag
  },
  neoCodeVisible: state => state.neoCodeVisible,
  dynedJumpVisible: state => state.dynedJumpVisible,
  languageDialogVisible: state => state.languageDialogVisible
}
const mutations = {
	SETKEEPALIVE: (state, keepAlive) => {
	  state.keepAlive = global.unique(keepAlive)
	},

  // 加面包屑的url数组
  SETBREADCRUMBURLARR(state, arr) {
    sessionStorage.setItem('breadcrumbUrlArr', JSON.stringify(arr))
    state.breadcrumbUrlArr = arr
  },
  // 设置顶部菜单激活状态 
  SETMENUCURSTATE(state, path) {
		let curMenu = 3
		if(path.indexOf('/study') >= 0){
			curMenu = 1
		}else if(path.indexOf('/my') >= 0){
			curMenu = 2
		}else if(path.indexOf('/follow') >= 0){
			curMenu = 2
		}else if(path.indexOf('/survey') >= 0){
			curMenu = 2
		}else if(path.indexOf('/articleDetails') >= 0){
			curMenu = 3
		}else if(path.indexOf('/learningGoal/subscribed') >= 0){
			curMenu = 3
		}
    state.curMenu = curMenu
  },

  SETROLE(state, role) {
    state.role = role;
  },
  INITUSERINFO(state, info) {
    // let usrInfo = JSON.parse(info);
    // usrInfo.schoolId = usrInfo.schoolId
    state.userInfo = info;
  },
  INITCOURSEWARELIST(state, list) {
    state.courseWareList = list
  },
  CHANGETITLE(state, title) {
    state.title = title
  },
  SETUSERID(state, userId) {
    state.userId = parseInt(userId)
  },
  SETTOKEN(state, token) {
    state.token = token
  },
  SETHOVERSTATE(state, isHover) {
    state.isHover = isHover
  },
  CHANGELANG(state, lang) {
    let now_lang = lang=='en' ? 1 : (lang=='tw' ? 2 : 0);
    state.lang = lang;
    localStorage.setItem("now_lang", now_lang);
    localStorage.setItem('lang', lang)
  },
  CHANGEUPLOADFILEPERCENT(state, value) {
    state.uploadFilePercent = value
  },
  CHANGEUPLOADFILEDIALOGVISIBLE(state, value) {
    state.uploadFileDialogVisible = value
  },
  SETNOREADMSGLIST(state, noReadMsgList) {
    state.noReadMsgList = noReadMsgList
  },
  CHANGEINITPAGE(state, initPageFlag) {
    sessionStorage.setItem('initPageFlag', JSON.stringify(initPageFlag))
    state.initPageFlag = initPageFlag
  },
  CHANGENEOCODEVISIBLE(state, neoCodeVisible) {
    state.neoCodeVisible = neoCodeVisible
  },
  CHANGEDYNEDJUMPVISIBLE(state, dynedJumpVisible) {
    state.dynedJumpVisible = dynedJumpVisible
  },
  CHANGELANGUAGEDIALOGVISIBLE(state, languageDialogVisible) {
    state.languageDialogVisible = languageDialogVisible
  },
  
}

const actions = {
	setkeepalive({ commit }, value) {
	  commit('SETKEEPALIVE', value)
	},
  async initCourseWareList({ commit }, promise) {
    commit('INITCOURSEWARELIST', await request.get(`${WITSBOX_ENV_PARAM.baseUrl}/course/lesson/${promise.lessonId}`))
  },
  initUserInfo({
    commit
  }, value) {
    commit('INITUSERINFO', value)
  },
  setUserId({
    commit
  }, value) {
    commit('SETUSERID', value)
  },
  setToken({
    commit
  }, value) {
    commit('SETTOKEN', value)
  },
  changeTitle({
    commit
  }, value) {
    commit('CHANGETITLE', value)
  },
  changeLang({
    commit
  }, value) {
    commit('CHANGELANG', value)
  },
  changeUploadFilePercent({
    commit
  }, value) {
    commit('CHANGEUPLOADFILEPERCENT', value)
  },
  changeUploadFileDialogVisible({
    commit
  }, value) {
    commit('CHANGEUPLOADFILEDIALOGVISIBLE', value)
  },
  setNoReadMsgList({
    commit
  }, value) {
    commit('SETNOREADMSGLIST', value)
  },
  
  changeNeoCodeVisible({
    commit
  }, value) {
    commit('CHANGENEOCODEVISIBLE', value)
  },
  changeDynedJumpVisible({
    commit
  }, value) {
    commit('CHANGEDYNEDJUMPVISIBLE', value)
  },
  changeLanguageDialogVisible({
    commit
  }, value) {
    commit('CHANGELANGUAGEDIALOGVISIBLE', value)
  },
  
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./store/modules/common.js